import { render, staticRenderFns } from "./EducationPage.vue?vue&type=template&id=65dbb229&"
import script from "./EducationPage.vue?vue&type=script&lang=js&"
export * from "./EducationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65dbb229')) {
      api.createRecord('65dbb229', component.options)
    } else {
      api.reload('65dbb229', component.options)
    }
    module.hot.accept("./EducationPage.vue?vue&type=template&id=65dbb229&", function () {
      api.rerender('65dbb229', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Education/EducationPage.vue"
export default component.exports